/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Home_Story_Badge_Text1Inputs */

const vi_sitesettings_home_story_badge_text1 = /** @type {(inputs: Sitesettings_Home_Story_Badge_Text1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhãn ô câu chuyện`)
};

/**

* @param {Sitesettings_Home_Story_Badge_Text1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_home_story_badge_text1 = /** @type {((inputs?: Sitesettings_Home_Story_Badge_Text1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Home_Story_Badge_Text1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_home_story_badge_text1(inputs)
});
export { sitesettings_home_story_badge_text1 as "siteSettings_home_story_badge_text" }